import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "components/shared/BackButton";
import { StyledStack, ButtonContainer, StyledTitle } from "./AddCategory.style";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CheckIcon from "@mui/icons-material/Check";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import { CategorySchema } from "validations";
import { addCategoryNewsRequest } from "api/requests";
import {
  Grid,
  Button,
  TextField,
} from "@mui/material";

export default function AddCategory() {
  const navigate = useNavigate();
  const { request, loading } =
    useHttp(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(CategorySchema),
  });

  const onSubmit = async (data) => {
    const res = await request({
      url: addCategoryNewsRequest,
      values: { ...data },
    });

    if (res) {
      Toast({ type: "success", title: "ثبت زیردسته" });
      navigate(-1);
    }
  };

  return (
    <DrawerCM title="افزودن زیردسته آموزش">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <Grid item mt={3} xs={12}>
            <BackButton />
          </Grid>
          <StyledStack>
            <StyledTitle>افزودن زیردسته آموزش</StyledTitle>
            <Grid container>
              <Grid item md={12} xs={12} p={1.5}>
                <TextField
                  label="عنوان"
                  variant="outlined"
                  fullWidth
                  id="title"
                  {...register("title")}
                  error={Boolean(errors.title)}
                  helpertext={errors.title?.message}
                />
              </Grid>
              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
